import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { addAgentAction, updateAgentAction } from "../../../Redux/Action/AgentAction";
import CommonDatePicker from "../../CommonComponent/DatePickerComponent/CommonDatePicker";
import Regex from "../../../Utilities/Regex";
import { MemberContext } from "../AllMemberComponent";
import { useDispatch } from "react-redux";
import { addMemberAction, editMemberAction, findMemberByMobileAction } from "../../../Redux/Action/MemberAction";
import Auth from "../../../Utilities/Auth";
import Select from "react-select";
import { locations } from '../../../formatted_state_and_district';

function MemberForm({ formType = "add" }) {
    const {
        setAllMemberReload,
        setAddMemberModelShow,
        getSingleMemberData,
        setEditMemberModelShow,
        setGetSingleMemberData,
        memberIdCardModelShow,
        setMemberIdCardModelShow,
        setIdData
    } = useContext(MemberContext)

    // ref
    const btnRef = useRef()
    const dispatch = useDispatch()
    // states
    const [dob, setDob] = useState(null)
    // getting auth data
    let agentDetail = JSON.parse(Auth.header().userdetail || "{}")
    //Hook Form
    const { control, register, handleSubmit, getValues, reset, setValue, formState: { errors } } = useForm();
    // states

    const [selectedState, setSelectedState] = useState(null);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedAreaType, setSelectedAreaType] = useState(null);
    const [reRenderThisComponent, setReRenderThisComponent] = useState(false)

    // Convert states into React Select format
    const stateOptions = locations.map((item) => ({
        value: item.state_name,
        label: item.state_name,
    }));

    // District options based on selected state
    const districtOptions =
        selectedState
            ? locations
                .find((s) => s.state_name === selectedState.value)
                ?.districts.map((d) => ({
                    value: d.district_name,
                    label: d.district_name,
                })) || []
            : [];


    // Area type
    const area_type = [
        { value: "block", label: "Block" },
        { value: "municipality", label: "Municipality" },

    ];

    useEffect(() => {
        if (Object.keys(getSingleMemberData).length != 0) {
            Object.keys(getValues()).map(fieldProp => {
                if (fieldProp == "state") {
                    // formData.append(fieldName, data[fieldName].value)
                    setValue(fieldProp, { label: getSingleMemberData[fieldProp], value: getSingleMemberData[fieldProp] })

                    // set their own districts
                    let state_with_their_districts = null
                    for (const S of stateOptions) {
                        if (S.value.toLocaleLowerCase() == getSingleMemberData[fieldProp].toLocaleLowerCase()) {
                            state_with_their_districts = S
                            break;
                        }
                    }

                    // console.log(state_with_their_districts)
                    setSelectedState(state_with_their_districts)

                } else if (fieldProp == "district") {
                    // formData.append(fieldName, data[fieldName].value)
                    setValue(fieldProp, { label: getSingleMemberData[fieldProp], value: getSingleMemberData[fieldProp] })
                } else if (fieldProp == "area_type") {
                    // formData.append(fieldName, data[fieldName].value)
                    setValue(fieldProp, { label: getSingleMemberData[fieldProp], value: getSingleMemberData[fieldProp] })
                } else {
                    setValue(fieldProp, getSingleMemberData[fieldProp])
                }
            })
        } else {
            if (agentDetail.is_admin == 0) {
                setValue("agent_id", agentDetail.id)
            }
        }
        setReRenderThisComponent(prev => !prev)
    }, [getSingleMemberData])

    const onSubmit = data => {
        const payload = {
            data,
            reset,
            btnRef,
            setAllMemberReload,
            setAddMemberModelShow,
            setEditMemberModelShow,
            setGetSingleMemberData
        }

        if (Object.keys(getSingleMemberData).length == 0) {
            const newData = {
                ...data,
                state: data?.state?.value || "",
                district: data?.district?.value || "",
                area_type: data?.area_type?.value || "",
                grade: ""
            }
            payload.data = newData

            // payload.setMemberIdCardModelShow = setMemberIdCardModelShow
            payload.setIdData = setIdData
            dispatch(addMemberAction(payload))


        } else {
            const newData = {
                ...data, date_of_birth: dob, member_id: getSingleMemberData.id,
                state: data?.state?.value || "",
                district: data?.district?.value || "",
                area_type: data?.area_type?.value || "",
                grade: data.grade,
            }
            payload.data = newData
            payload.setEditMemberModelShow = setEditMemberModelShow
            payload.setGetSingleMemberData = setGetSingleMemberData
            dispatch(editMemberAction(payload))
        }
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Full Name</Form.Label>
                            <Form.Control
                                type="text"
                                // placeholder="Enter Member Name"
                                {...register("member_name", {
                                    required: true
                                })}
                            />

                            {/* validation message*/}
                            {errors.member_name && <span className="text-danger">
                                {errors.member_name.type === "required" && "Please Give Member Name"}
                            </span>}
                        </Form.Group>

                    </Col>
                    {Object.keys(getSingleMemberData).length != 0 ? <><Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Grade</Form.Label>
                            <Form.Control
                                disabled={!agentDetail.is_admin}
                                type="text"
                                // placeholder="Enter Grade"
                                {...register("grade", {
                                    required: false
                                })}
                            />

                        </Form.Group>

                    </Col></> : ""}


                    {/* <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Guardian Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter Guardian Name"
                                {...register("guardian", {
                                    required: false
                                })}
                            />


                            {errors.guardian && <span className="text-danger">
                                {errors.guardian.type === "required" && "Please Give Guardian Name"}
                            </span>}
                        </Form.Group>

                    </Col> */}

                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Mobile No.</Form.Label>
                            <Form.Control
                                // id='memberMobileField'
                                type="text"
                                // placeholder="Enter Mobile No."
                                maxLength={10} // <-- Hard limit on input
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
                                }}
                                {...register("mobile", {
                                    required: true,
                                    pattern: Regex.numeric(),
                                    minLength: 10
                                })}
                                onBlur={(e) => {
                                    const mobile = +e?.target?.value || 0
                                    if (mobile > 9) {
                                        // handle field disablity
                                        const handleFieldDisability = (disable_status) => {
                                            e.target.disabled = disable_status || false
                                        }
                                        // making payload
                                        const payload = {
                                            data: { mobile },
                                            member_id: getSingleMemberData?.id || null,
                                            formType,
                                            handleFieldDisability,
                                            setGetSingleMemberData
                                        }

                                        // action dispatch
                                        dispatch(findMemberByMobileAction(payload))
                                    }
                                }}
                            />

                            {/* validation message*/}
                            {errors.mobile && <span className="text-danger">
                                {errors.mobile.type === "required" && "Please Give Mobile No."}
                                {errors.mobile.type === "pattern" && "Please Give Valid Mobile No."}
                                {errors.mobile.type === "minLength" && "Mobile No. must should at least 10 digits."}

                            </span>}
                        </Form.Group>
                    </Col>
                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>
                                WhatsApp No. &nbsp;
                                <span
                                    className=" text-decoration-underline "
                                    style={{ "cursor": "pointer" }}
                                    onClick={(e) => {
                                        setValue("whats_app", getValues("mobile"))
                                        setReRenderThisComponent(prev => !prev)
                                    }}
                                >( Same As Mobile ✓ )</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                // placeholder="Enter whatsApp No."
                                maxLength={10} // <-- Hard limit on input
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
                                }}
                                {...register("whats_app", {
                                    required: false,
                                    pattern: Regex.numeric(),
                                    minLength: 10
                                })}
                            />

                            {/* validation message*/}
                            {errors.whats_app && <span className="text-danger">
                                {errors.whats_app.type === "required" && "Please Give WhatsApp No."}
                                {errors.whats_app.type === "pattern" && "Please Give Valid WhatsApp No."}
                                {errors.whats_app.type === "minLength" && "Mobile No. must should at least 10 digits."}

                            </span>}
                        </Form.Group>
                    </Col>
                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>State</Form.Label>
                            <Controller
                                name="state"
                                control={control}
                                // rules={{ required: "State is required" }}
                                rules={{ required: false }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        value={getValues("state") ? getValues("state") : null}
                                        options={stateOptions}
                                        placeholder="Select State"
                                        onChange={(value) => {
                                            field.onChange(value);
                                            setSelectedState(value);
                                            setSelectedState(value || null);
                                            setValue("district", null)
                                            // setReRenderThisComponent(prev => !prev)
                                        }}
                                    />
                                )}
                            />


                            {/* validation message*/}
                            {errors.state && <span className="text-danger">
                                {errors.state.type === "required" && "Please Select State"}
                            </span>}
                        </Form.Group>
                    </Col>

                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>District</Form.Label>
                            <Controller
                                name="district"
                                control={control}
                                // rules={{ required: "District is required" }}
                                rules={{ required: false }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        value={getValues("district") ? getValues("district") : null}
                                        options={districtOptions}
                                        placeholder="Select District"
                                        isDisabled={!selectedState}
                                        onChange={field.onChange}
                                    />
                                )}
                            />


                            {/* validation message*/}
                            {errors.collection_area_district && <span className="text-danger">
                                {errors.collection_area_district.type === "required" && "Please Select District"}
                            </span>}
                        </Form.Group>
                    </Col>

                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Police Station</Form.Label>
                            <Form.Control
                                type="text"
                                // placeholder="Enter Police Station"
                                {...register("police_station", {
                                    required: false
                                })}
                            />

                            {/* validation message*/}
                            {errors.collection_area_police_station && <span className="text-danger">
                                {errors.collection_area_police_station.type === "required" && "Please Give Police Station"}
                            </span>}
                        </Form.Group>
                    </Col>



                    <Col md={3} sm={12} className='d-none'>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Post Office</Form.Label>
                            <Form.Control
                                type="text"
                                // placeholder="Enter Post Office"
                                {...register("post_office", {
                                    required: false
                                })}
                            />

                            {/* validation message*/}
                            {errors.post_office && <span className="text-danger">
                                {errors.post_office.type === "required" && "Please Give Post Office"}
                            </span>}
                        </Form.Group>
                    </Col>
                    <Col md={3} sm={12} className='d-none'>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Pincode</Form.Label>
                            <Form.Control
                                type="text"
                                // placeholder="Enter Pincode"
                                {...register("pincode", {
                                    required: false,
                                    pattern: Regex.numeric()
                                })}
                            />

                            {/* validation message*/}
                            {errors.pincode && <span className="text-danger">
                                {errors.pincode.type === "required" && "Please Give Village Name"}
                                {errors.pincode.type === "pattern" && "Please Give Valid agent id"}
                            </span>}
                        </Form.Group>
                    </Col>
                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Village</Form.Label>
                            <Form.Control
                                type="text"
                                // placeholder="Enter Village Name"
                                {...register("village", {
                                    required: false
                                })}
                            />

                            {/* validation message*/}
                            {errors.village && <span className="text-danger">
                                {errors.village.type === "required" && "Please Give Village Name"}
                            </span>}
                        </Form.Group>
                    </Col>


                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Neighborhood</Form.Label>
                            <Form.Control
                                type="text"
                                // placeholder="Enter Neighborhood"
                                {...register("neighborhood", {
                                    required: false,

                                })}
                            />


                        </Form.Group>
                    </Col>
                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Place</Form.Label>
                            <Form.Control
                                type="text"
                                // placeholder="Enter Place"
                                {...register("place", {
                                    required: false
                                })}
                            />

                            {/* validation message*/}
                            {errors.place && <span className="text-danger">
                                {errors.place.type === "required" && "Please Give Village Name"}
                            </span>}
                        </Form.Group>
                    </Col>
                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>City</Form.Label>
                            <Form.Control
                                type="text"
                                // placeholder="Enter Neighborhood"
                                {...register("city", {
                                    required: false,

                                })}
                            />


                        </Form.Group>
                    </Col>

                    <Col md={6} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Collector Id</Form.Label>
                            <Form.Control
                                defaultValue={agentDetail.is_admin != 1 ? agentDetail.id : ""}
                                disabled={!agentDetail.is_admin}
                                type="text"
                                // placeholder="Enter collector id"
                                {...register("agent_id", {
                                    required: true,
                                    pattern: Regex.numeric()
                                })}
                            />

                            {/* validation message*/}
                            {errors.agent_id && <span className="text-danger">
                                {errors.agent_id.type === "required" && "Please Give collector id"}
                                {errors.agent_id.type === "pattern" && "Please Give Valid collector id"}

                            </span>}
                        </Form.Group>
                    </Col>




                </Row>

                <Button ref={btnRef} variant="primary" type="submit" className="submit">
                    {Object.keys(getSingleMemberData).length == 0 ? "Submit" : "Update"}
                </Button>

            </form>
        </>
    );
}

export default MemberForm;